export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6559.a4aaea44.jpg";